import {FormAjaxClass} from "./form-ajax.class";

export class FormValidateClass {
    readonly FORM_CLASS = '.js-form';
    readonly FORM_SUBMIT_CLASS = '.js-form-submit';
    readonly INPUT_CLASS_SUCCESS = 'is-valid';
    readonly INPUT_CLASS_ERROR = 'is-invalid';
    readonly INPUT_CAPTCHA_NAME = 'g-recaptcha-response';
    readonly VISIBILITY_CLASS = 'd-none';
    private readonly FORM_SUCCESS_SELECTOR = '.js-form-feedback-success';
    private readonly FORM_ERROR_SELECTOR = '.js-form-feedback-error';
    private readonly FORM_POST_ERROR_SELECTOR = '.js-form-feedback-post-error';
    private readonly FORM_FEEDBACK_SELECTOR = '.js-form-feedback';
    readonly buttonList = document.querySelectorAll(this.FORM_SUBMIT_CLASS);

    private readonly formAjax = new FormAjaxClass();

    constructor() {
        if (this.buttonList.length > 0) {
            this.listen()
        }
    }

    listen (): void {
        for (let i = this.buttonList.length - 1; i >= 0; i--) {
            this.buttonList[i].addEventListener('click', (e) => this.onSubmit(e))
        }
    }

    onSubmit (e: Event): void {
        e.preventDefault();
        let $form: HTMLFormElement | null = (e.target as HTMLElement).closest(this.FORM_CLASS);
        let inputList: HTMLFormControlsCollection = $form.elements;

        this.loading($form, true);

        if (inputList.length > 0) {
            this.filterInput(inputList)
        }

        if (!this.hasRequiredInputWithError(Array.from(inputList))) {
            if (this.formAjax.isActive($form) === true) {
                this.formAjax.formSubmit($form, (form: HTMLFormElement, status: string, message: string) => this.formCallback(form, status, message))
            } else {
                $form.submit()
            }
        } else {
            this.formRequiredCallback($form)
        }
    }

    private formRequiredCallback(form: HTMLFormElement): void {
        this.loading(form, false);
        this.hideAllFeedbackBut(form, this.FORM_ERROR_SELECTOR);
    }

    private hasRequiredInputWithError (inputList: Element[]): boolean {
        return inputList
            .filter(input => (input as HTMLInputElement).required)
            .some(input => input.classList.contains(this.INPUT_CLASS_ERROR));
    }

    formCallback (form: HTMLFormElement, status: string, message = ''): void {
        this.loading(form, false);

        if (status === 'success') {
            if (form.classList.contains('js-form-rolex') && typeof window._satellite !== 'undefined') {
                window._satellite.track("contactForm")
            }
            this.hideAllFeedbackBut(form, this.FORM_SUCCESS_SELECTOR);
            this.disableForm(form)
        } else {
            const errorFullFeedback = form
                .querySelector(this.FORM_POST_ERROR_SELECTOR)
                .querySelector<HTMLElement>('.js-error');
            if (errorFullFeedback) {
                errorFullFeedback.innerText = message;
            }

            this.hideAllFeedbackBut(form, this.FORM_POST_ERROR_SELECTOR);
        }
    }

    private hideAllFeedbackBut(form: HTMLFormElement, visibleFeedbackSelector: string): void {
        const feedbacks = Array.from(form.querySelectorAll<HTMLElement>(this.FORM_FEEDBACK_SELECTOR));

        feedbacks.forEach(feedback => {
            feedback.classList.add(this.VISIBILITY_CLASS);
        });

        form.querySelector(visibleFeedbackSelector).classList.remove(this.VISIBILITY_CLASS);
    }

    disableForm (form: HTMLFormElement): void {
        let formElement: HTMLFormControlsCollection = form.elements;

        for (let i = formElement.length - 1; i >= 0; i--) {
            (formElement[i] as HTMLInputElement).disabled = true
        }
        form.disabled = true;
        form.classList.add('is-disabled')
    }

    loading (form: HTMLFormElement, status: boolean): void {
        let $submit = form.querySelector(this.FORM_SUBMIT_CLASS);
        $submit.classList.toggle('is-loading', status)
    }

    filterInput (list: HTMLFormControlsCollection) {
        for (let i = list.length - 1; i >= 0; i--) {
            let $input: any = list[i];

            if (!$input.required && !this.inputIsCaptcha($input.name)) {
                continue
            }

            let type: string = this.getInputType($input);
            if (this.inputIsText(type) || this.inputIsCaptcha(type)) {
                this.validateText($input)
            } else if (this.inputIsEmail(type)) {
                this.validateEmail($input)
            } else if (this.inputIsCheckboxRadio(type)) {
                this.validateCheckboxRadio($input, list)
            } else if (this.inputIsSelect(type)) {
                this.validateSelect($input)
            } else if (this.inputIsTextArea(type)) {
                this.validateTextArea($input)
            } else {
                console.warn('unknow input', $input, type)
            }
        }
    }

    toggleClass (input: HTMLElement, add: string, remove: string): void {
        input.classList.add(add);
        input.classList.remove(remove);
    }

    validateSelect (input: HTMLSelectElement): void {
        let classToAdd = input.selectedIndex === 0 ? this.INPUT_CLASS_ERROR : this.INPUT_CLASS_SUCCESS;
        let classToRemove = input.selectedIndex === 0 ? this.INPUT_CLASS_SUCCESS : this.INPUT_CLASS_ERROR;

        this.toggleClass(input, classToAdd, classToRemove)
    }

    validateTextArea (input: HTMLInputElement): void {
        this.validateText(input)
    }

    validateCheckboxRadio (input: HTMLInputElement, list: HTMLFormControlsCollection): void {
        let name: string = input.name;
        let siblingList = this.getSibling(name, list);
        let hasChecked = false;
        let classToAdd, classToRemove;

        for (var i = siblingList.length - 1; i >= 0; i--) {
            let $input = siblingList[i];

            if ($input.checked === true) {
                hasChecked = true
            }
        }

        classToAdd = hasChecked === false ? this.INPUT_CLASS_ERROR : this.INPUT_CLASS_SUCCESS;
        classToRemove = hasChecked === false ? this.INPUT_CLASS_SUCCESS : this.INPUT_CLASS_ERROR;

        for (let i = siblingList.length - 1; i >= 0; i--) {
            this.toggleClass(siblingList[i], classToAdd, classToRemove);
        }
    }

    validateEmail (input: HTMLInputElement): void {
        this.validateText(input)
    }

    validateText (input: HTMLInputElement): void {
        let val = input.value;
        let classToAdd = val === '' ? this.INPUT_CLASS_ERROR : this.INPUT_CLASS_SUCCESS;
        let classToRemove = val === '' ? this.INPUT_CLASS_SUCCESS : this.INPUT_CLASS_ERROR;

        this.toggleClass(input, classToAdd, classToRemove)
    }

    getInputType (input: HTMLInputElement|HTMLSelectElement|HTMLTextAreaElement): string {
        if (input.nodeName === 'SELECT') {
            return 'select'
        } else if (input.nodeName === 'TEXTAREA') {
            return 'textarea'
        } else if (input.name === this.INPUT_CAPTCHA_NAME) {
            return this.INPUT_CAPTCHA_NAME
        } else {
            return input.type
        }
    }

    getSibling (name: string, list: HTMLFormControlsCollection): HTMLInputElement[] {
        let siblingList = [];
        for (let i = list.length - 1; i >= 0; i--) {
            let $input: any = list[i];

            if ($input.name === name) {
                siblingList.push($input)
            }
        }

        return siblingList
    }

    inputIsText (type: string): boolean {
        return type === 'text' || type === 'number' || type === 'tel'
    }

    inputIsEmail (type: string): boolean {
        return type === 'email'
    }

    inputIsSelect (type: string): boolean {
        return type === 'select'
    }

    inputIsCaptcha (type: string): boolean {
        return type === this.INPUT_CAPTCHA_NAME
    }

    inputIsTextArea (type: string): boolean {
        return type === 'textarea'
    }

    inputIsCheckboxRadio (type: string): boolean {
        return type === 'checkbox' || type === 'radio'
    }
}
